export const GOLD = "#d4af6a";
export const GOLD_LIGHT = "#f0d999";
export const DEEP_BLUE = "#050b2e";
export const MID_BLUE = "#0a1856";
export const PANEL_BLUE = "#0d1d63";

export const styles = {
  shell: {
    minHeight: "100vh",
    width: "100%",
    background: `radial-gradient(ellipse at 30% 20%, ${MID_BLUE} 0%, ${DEEP_BLUE} 65%)`,
    fontFamily: "Georgia, 'Times New Roman', serif",
    color: "#f3eee0",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    overflow: "hidden",
  },
  featherGlow: {
    position: "absolute",
    top: "-10%",
    right: "-10%",
    width: "55%",
    height: "120%",
    background:
      "radial-gradient(circle at 60% 30%, rgba(60,160,140,0.18), rgba(40,90,160,0.08) 50%, transparent 75%)",
    pointerEvents: "none",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "28px 48px",
    position: "relative",
    zIndex: 2,
    flexWrap: "wrap",
    gap: "20px",
  },
  brandRow: { display: "flex", alignItems: "center", gap: "14px" },
  crest: {
    width: "48px",
    height: "48px",
    borderRadius: "50%",
    border: `2px solid ${GOLD}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: GOLD_LIGHT,
    fontSize: "16px",
    letterSpacing: "1px",
    background: "rgba(212,175,106,0.08)",
    textDecoration: "none",
  },
  brandName: {
    fontSize: "19px",
    letterSpacing: "0.5px",
    color: "#f3eee0",
  },
  brandSub: {
    fontSize: "12px",
    color: GOLD,
    letterSpacing: "1px",
    textTransform: "uppercase",
  },
  nav: {
    display: "flex",
    alignItems: "center",
    gap: "18px",
    background: "rgba(255,255,255,0.03)",
    border: "1px solid rgba(212,175,106,0.35)",
    borderRadius: "999px",
    padding: "8px 20px",
  },
  navDivider: {
    width: "1px",
    height: "20px",
    background: "rgba(212,175,106,0.4)",
  },
  navLink: {
    background: "transparent",
    border: "none",
    color: "#cfd3e6",
    fontFamily: "inherit",
    fontSize: "15px",
    letterSpacing: "1px",
    textTransform: "uppercase",
    cursor: "pointer",
    padding: "6px 10px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    textDecoration: "none",
    borderBottom: "1px solid transparent",
  },
  navLinkActive: {
    color: GOLD_LIGHT,
    borderBottom: `1px solid ${GOLD}`,
  },
  navIcon: { fontSize: "16px" },
  main: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px 24px 80px",
    position: "relative",
    zIndex: 2,
  },
  heroSection: {
    maxWidth: "640px",
    textAlign: "center",
  },
  aboutSection: {
    maxWidth: "760px",
    textAlign: "center",
  },
  eyebrow: {
    color: GOLD,
    fontSize: "13px",
    letterSpacing: "3px",
    textTransform: "uppercase",
    marginBottom: "10px",
  },
  heroTitle: {
    fontSize: "34px",
    fontWeight: "normal",
    margin: "0 0 16px",
    color: "#f7f3e6",
  },
  goldRule: {
    width: "70px",
    height: "1px",
    background: GOLD,
    margin: "0 auto 24px",
  },
  heroText: {
    fontSize: "16px",
    lineHeight: "1.8",
    color: "#cdd2e8",
    marginBottom: "36px",
  },
  aboutText: {
    fontSize: "15px",
    lineHeight: "1.8",
    color: "#cdd2e8",
    marginTop: "10px",
    textAlign: "left",
  },
  aboutTextHighlight: {
    fontSize: "15px",
    lineHeight: "1.8",
    color: "#f3eee0",
    textAlign: "left",
    fontStyle: "italic",
    borderLeft: `2px solid ${GOLD}`,
    paddingLeft: "16px",
    margin: "24px 0",
  },
  twoCol: {
    display: "flex",
    gap: "24px",
    flexWrap: "wrap",
    margin: "30px 0",
    textAlign: "left",
  },
  infoBlock: {
    flex: "1 1 280px",
    background: PANEL_BLUE,
    border: "1px solid rgba(212,175,106,0.25)",
    borderRadius: "12px",
    padding: "20px 22px",
  },
  blockTitle: {
    fontSize: "13px",
    letterSpacing: "1.5px",
    textTransform: "uppercase",
    color: GOLD,
    marginBottom: "10px",
  },
  blockText: {
    fontSize: "14px",
    lineHeight: "1.7",
    color: "#cdd2e8",
    margin: 0,
  },
  list: {
    margin: 0,
    paddingLeft: "18px",
    fontSize: "14px",
    lineHeight: "1.8",
    color: "#cdd2e8",
  },
  quickContact: {
    display: "flex",
    justifyContent: "center",
    gap: "40px",
    flexWrap: "wrap",
  },
  quickItem: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  quickLabel: {
    fontSize: "12px",
    letterSpacing: "1.5px",
    textTransform: "uppercase",
    color: GOLD,
  },
  quickValue: {
    fontSize: "16px",
    color: "#f3eee0",
  },
  card: {
    background: PANEL_BLUE,
    border: `1px solid rgba(212,175,106,0.4)`,
    borderRadius: "16px",
    padding: "32px",
    display: "flex",
    alignItems: "center",
    gap: "24px",
    textAlign: "left",
    margin: "0 auto",
  },
  avatar: {
    width: "72px",
    height: "72px",
    minWidth: "72px",
    borderRadius: "50%",
    border: `2px solid ${GOLD}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "22px",
    color: GOLD_LIGHT,
    background: "rgba(212,175,106,0.08)",
  },
  cardBody: { flex: 1 },
  cardName: { fontSize: "22px", color: "#f7f3e6" },
  cardRole: {
    fontSize: "13px",
    letterSpacing: "2px",
    textTransform: "uppercase",
    color: GOLD,
    marginBottom: "14px",
  },
  infoRow: {
    display: "flex",
    justifyContent: "space-between",
    gap: "16px",
    borderTop: "1px solid rgba(212,175,106,0.2)",
    padding: "8px 0",
    fontSize: "14px",
  },
  infoLabel: { color: "#9aa0c0", whiteSpace: "nowrap" },
  infoValue: { color: "#f3eee0", textAlign: "right" },
  tagWrap: {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    justifyContent: "center",
    marginTop: "26px",
  },
  tag: {
    fontSize: "12px",
    letterSpacing: "0.5px",
    color: GOLD_LIGHT,
    border: "1px solid rgba(212,175,106,0.4)",
    borderRadius: "999px",
    padding: "6px 14px",
  },
  footer: {
    textAlign: "center",
    padding: "18px",
    fontSize: "12px",
    color: "#7b81a8",
    borderTop: "1px solid rgba(212,175,106,0.15)",
    position: "relative",
    zIndex: 2,
  },
};
